import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { LockKey, CheckCircle } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("As senhas não coincidem"); return; }
    if (password.length < 6) { toast.error("Senha precisa ter ao menos 6 caracteres"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      toast.success("Senha redefinida!");
      setTimeout(() => nav("/"), 1500);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <div className="max-w-md mx-auto px-4 py-12 text-center" data-testid="reset-password-no-token">
        <p className="text-slate-600">Link inválido.</p>
        <Link to="/esqueci-senha" className="btn-primary mt-4 inline-flex">Solicitar novo link</Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-4 py-8" data-testid="reset-password-page">
      <div className="aj-card p-6">
        <div className="w-14 h-14 rounded-full bg-[#FF6B35]/10 flex items-center justify-center">
          {done ? <CheckCircle size={28} weight="duotone" color="#16A34A" /> : <LockKey size={28} weight="duotone" color="#FF6B35" />}
        </div>
        <h1 className="font-heading text-2xl font-black mt-3">
          {done ? "Senha redefinida!" : "Redefinir senha"}
        </h1>
        {!done ? (
          <form onSubmit={submit} className="space-y-3 mt-3">
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Nova senha (mín. 6 caracteres)"
              className="aj-input"
              data-testid="new-password-input"
            />
            <input
              type="password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Confirme a nova senha"
              className="aj-input"
              data-testid="confirm-password-input"
            />
            <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="reset-submit">
              {busy ? "Salvando..." : "Salvar nova senha"}
            </button>
          </form>
        ) : (
          <p className="text-sm text-slate-600 mt-2">Você será redirecionado em instantes...</p>
        )}
      </div>
    </div>
  );
}
